const finishedList = [
  {
    id: "完了",
    name: "完了",
    shortName: "完了",
  },
  {
    id: "未完了",
    name: "未完了",
    shortName: "未完了",
  },
];

export default finishedList;
